import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { fmtNumber, fmtCurrency } from '../lib/format';
import { SectionHeader, EmptyState } from '../components/ui';

interface Props {
  property: string;
}

export default function SEOSection({ property }: Props) {
  const [pages, setPages] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .moneyPages(property, 40)
      .then((d) => setPages(d.money_pages))
      .finally(() => setLoading(false));
  }, [property]);

  if (loading) return <div className="text-xs text-white/40 py-12 text-center">Loading…</div>;

  if (pages.length === 0) {
    return (
      <EmptyState
        title="Money pages — 40 per property"
        message="Tracked weekly. Position changes, revenue per page, week-on-week deltas. Money page list needs to be defined per property — use the Ahrefs Rank Tracker keyword lists, or add target keywords to a CSV at shared/money-pages.csv (loader TBD)."
      />
    );
  }

  return (
    <div className="raised-card">
      <SectionHeader title={`Money pages — ${property === 'ALL' ? 'all properties' : property}`} />
      <table className="w-full text-sm">
        <thead>
          <tr className="text-white/40 text-xs border-b border-border-subtle">
            <th className="text-left font-normal pb-2">Page</th>
            <th className="text-right font-normal pb-2">Position</th>
            <th className="text-right font-normal pb-2">Δ pos</th>
            <th className="text-right font-normal pb-2">Sessions</th>
            <th className="text-right font-normal pb-2">Revenue</th>
            <th className="text-right font-normal pb-2">Δ rev</th>
          </tr>
        </thead>
        <tbody>
          {pages.map((p, i) => (
            <tr key={i} className="border-b border-border-subtle/50 last:border-0">
              <td className="py-2.5 truncate max-w-0">
                <a
                  href={p.url}
                  target="_blank"
                  rel="noopener"
                  className="hover:text-blue-400 transition-colors"
                >
                  {p.title || p.url}
                </a>
              </td>
              <td className="text-right py-2.5">
                {p.avg_position != null ? p.avg_position.toFixed(1) : '—'}
              </td>
              <td className="text-right py-2.5">
                {p.position_delta == null ? (
                  <span className="text-white/30">—</span>
                ) : (
                  <span className={p.position_delta < 0 ? 'delta-up' : 'delta-down'}>
                    {p.position_delta < 0 ? '▲' : '▼'} {Math.abs(p.position_delta).toFixed(1)}
                  </span>
                )}
              </td>
              <td className="text-right py-2.5">{fmtNumber(p.sessions)}</td>
              <td className="text-right py-2.5">{fmtCurrency(p.revenue_aud)}</td>
              <td className="text-right py-2.5">
                {p.revenue_delta_pct == null ? (
                  <span className="text-white/30">—</span>
                ) : (
                  <span className={p.revenue_delta_pct >= 0 ? 'delta-up' : 'delta-down'}>
                    {p.revenue_delta_pct >= 0 ? '▲' : '▼'} {Math.abs(p.revenue_delta_pct).toFixed(1)}%
                  </span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
